import { useSplitTests } from '@api/lendingAPI/lapiHooks';
import type { definitions } from '@iwoca/lapi-client/edge';
import { Text } from '@ui';
import { FormattedMessage } from 'react-intl';

import messages from './PersonCard.messages';
import { FormattedName } from '../../../iwIntlProvider/FormattedName';
import { CheckShieldSVG } from '../../../svgComponents/checkShieldSVG';
import { EditSVG } from '../../../svgComponents/editSVG';

export function PersonCard({
    firstName,
    lastName,
    roles,
    onClick,
    isGuarantor
}: {
    firstName?: string;
    lastName?: string;
    roles?: definitions['person']['roles'];
    onClick: () => void;
    isGuarantor?: boolean;
}) {
    const noPgSplitTest = useSplitTests('no_pg_test_2025');
    return (
        <div className="rounded-s bg-structure-100 shadow-black-s">
            <div className="space-y-s p-l">
                <div className="flex justify-between">
                    <FormattedName firstName={firstName} lastName={lastName} />
                    <button
                        className="border-none bg-transparent fill-primary-10 stroke-primary-10 hover:cursor-pointer"
                        data-testid="edit_person"
                        onClick={onClick}
                    >
                        <EditSVG className="h-4 w-4" />
                    </button>
                </div>
                <div className="text-s font-reg" data-testid="person-roles">
                    <PersonCardRoles roles={roles} />
                </div>
            </div>
            {isGuarantor && !noPgSplitTest && (
                <div className="flex p-l">
                    <CheckShieldSVG className="mr-2xs" />
                    <Text className="text-s font-med">
                        <FormattedMessage {...messages.personalGuarantor} />
                    </Text>
                </div>
            )}
        </div>
    );
}

function PersonCardRoles({ roles }: { roles: definitions['person']['roles'] }) {
    const noPgSplitTest = useSplitTests('no_pg_test_2025');

    if (!roles) return <></>;

    let filtered_roles = roles.filter((role) => role !== 'authorised_person');
    if (noPgSplitTest) {
        filtered_roles = filtered_roles.filter((role) => role !== 'guarantor');
    }
    return (
        <>
            {filtered_roles.map((role, i) => {
                if (i + 1 === filtered_roles.length) {
                    return <FormattedMessage key={role} {...messages[role]} />;
                }

                return (
                    <FormattedMessage key={role} {...messages[role]}>
                        {(text) => `${text}, `}
                    </FormattedMessage>
                );
            })}
        </>
    );
}
